import { Application } from "@hotwired/stimulus"
import ViewerPreviewController from "./controllers/viewer_preview_controller"

Application.start().register("viewer-preview", ViewerPreviewController)
